import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Groups.css';

import eventImg01 from '../assets/imgs/event-01.jpg';
import eventImg02 from '../assets/imgs/event-02.jpg';
import eventImg03 from '../assets/imgs/event-03.jpg';
import eventImg04 from '../assets/imgs/event-04.jpg';
import eventImg05 from '../assets/imgs/event-05.jpg';
import eventImg06 from '../assets/imgs/event-06.jpg';
import eventImg07 from '../assets/imgs/event-07.jpg';
import eventImg08 from '../assets/imgs/event-08.jpg';

class Groups extends Component {
  render() {
    return (
      <div className="Groups" ref={div => (this.appContainer = div)}>
        <Header />
        <div className="Groups-container">
          <div className="Groups-top"></div>
          <div className="Groups-mid">
            <div className="Groups-header">PRIVATE EVENTS</div>
            <hr />
            <div className="Room-listing">
              <div className="Groups-title">TEAM BUILDING</div>
              <br />
              The Bunker Experience is a unique and fun way to challenge your company and serve as a team-building exercise. Escape games are an excellent way to see how your team performs under pressure and how well they work together. Escape rooms have become one of the most popular team-building activities because they encourage:
              <p>* Stronger communication *</p>
              <p>* Better collaboration *</p>
              <p>* Creative problem-solving *</p>
              <p>* Improved team morale *</p>
              <br />
              At The Bunker Experience, your team is dropped into a fully immersive post-apocalyptic world led by live actors. Working against the clock, teams have 50 minutes to solve puzzles, overcome challenges, and complete their mission together.
              <br /><br />
              It’s more than just a game—it’s a shared experience designed to bring teams closer together through excitement, strategy, and unforgettable moments.
              <br /><br />

              <hr></hr>
              <br></br>
              <div className="Groups-title">Celebrate in Your Own Private Bunker</div> <br />
              Looking for an unforgettable way to celebrate? Host your next special event with an exclusive private rental of The Bunker Experience. Whether you're planning a birthday, company party, holiday celebration, or another special occasion, we'll help you create an event your guests will talk about long after it's over.<br />
              <br /><br />

              <hr></hr>
              <br></br>
              <div className="Groups-title">Private Venue Rental — $399/hour</div> <br />
              Your rental includes exclusive use of our entire venue—we close the space to the public so your group has the bunker all to yourselves.<br></br>
              Your rental includes:<br /><br />

              <p>* Exclusive access to the entire venue *</p>
              <p>* Event setup and cleanup *</p>
              <p>* An additional hour after your escape room games to eat, socialize, and celebrate *</p>
              <p>* Tables, chairs, and music *</p>
              <p>* A one-of-a-kind industrial, post-apocalyptic setting unlike any other event space *</p>
              <p>(Please note: Escape room tickets and food are not included in the rental fee.)</p>
              <br /><br />

              <hr></hr>
              <br></br>
              <div className="Groups-title">Food & Drinks</div> <br />
              You're welcome to bring your own food and beverages, or order from one of the many excellent local restaurants that offer delivery. Located in the heart of Old Town Pasadena, The Bunker Experience is surrounded by a great selection of restaurants, all within walking distance.
              <br></br><br></br>
              Make your next celebration anything but ordinary—give your guests an immersive experience they won't soon forget.
              <br></br><br></br>
              Contact us today to book your private event!
              <br></br><br></br><br></br>

              <hr />
              <br></br>
              <div className="Groups-title">CALL FOR DETAILS: (626) 487-9777</div>
              <hr></hr><br></br><br></br>

              <div className="Events-img"><img src={eventImg01} alt="" /></div>
              <div className="Events-img"><img src={eventImg02} alt="" /></div>
              <div className="Events-img"><img src={eventImg07} alt="" /></div>
              <div className="Events-img"><img src={eventImg04} alt="" /></div>
              <div className="Events-img"><img src={eventImg03} alt="" /></div>
              <div className="Events-img"><img src={eventImg06} alt="" /></div>
              <div className="Events-img"><img src={eventImg08} alt="" /></div>
              <div className="Events-img"><img src={eventImg05} alt="" /></div>
                   

            </div>
          </div>
          <div className="Groups-bottom"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Groups;
